import { useState, useEffect } from 'react';
import { TopToolbar, useRecordContext, AutocompleteInput, ExportButton, Button, List, Datagrid, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField } from 'react-admin';
import IconAdd from '@mui/icons-material/Add';

import * as React from 'react';
import Box from '@mui/material/Box';
//import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import {default as MUITextField} from '@mui/material/TextField';
import {default as MUIButton} from '@mui/material/Button';
import {default as MUIButtonGroup} from '@mui/material/ButtonGroup';
import {default as MUIMenuItem} from '@mui/material/MenuItem';
import {default as MUISelect} from '@mui/material/Select';
import {default as FormControl} from '@mui/material/FormControl';

import {fetcherGetSync, fetcherSync} from "../utils/fetcher";
import config from "../config";

import {convertToValidMomentDate, utcToTimezone, timezoneToUtc, timestampToStrDate} from "../utils/utils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const titleStyle = {
    textAlign: "center"
}

const buttonGroupStyle = {
    marginTop: "20px"
}

const inputDateTimeStyle = {
    display: "block",
    margin: "auto"
}

function orderPickup(orderId, date){
    try {
        let res = fetcherSync(config.API_HOST+"/orders/"+orderId+"/stuart/createPickup", "POST", {
            pickUpDate: date
        });
        if(res.orderId){
            alert("Demande confirmée.");
            window.location.reload();
        }
        else {
            alert("Une erreur s'est produite, vérifiez que la date demandée ne soit pas déjà passée ou trop loin dans le futur.");
        }
    }
    catch(e){
        alert("Une erreur s'est produite, vérifiez que la date demandée ne soit pas déjà passée ou trop loin dans le futur.");
    }
}

function orderDelivery(orderId, date){
    try {
        let res = fetcherSync(config.API_HOST+"/orders/"+orderId+"/stuart/createDelivery", "POST", {
            deliveredDate: date
        });
        if(res.orderId){
            alert("Demande confirmée.");
            window.location.reload();
        }
        else {
            alert("Une erreur s'est produite, vérifiez que la date demandée ne soit pas déjà passée ou trop loin dans le futur.");
        }
    }
    catch(e){
        alert("Une erreur s'est produite, vérifiez que la date demandée ne soit pas déjà passée ou trop loin dans le futur.");
    }
}

export default function OrderStuartJobModal(props) {
    const record = useRecordContext();
    const handleClose = () => props.setOpened(false);

    const [chosenDate, setChosenDate] = useState(utcToTimezone(props.date));
    //const [chosenDate, setChosenDate] = useState(convertToValidMomentDate(props.date));

    let opened = props.opened;

    const orderId = record.id;
    const type = props.type; // pickup or delivery

    return (
        <Modal
            open={opened}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2" style={titleStyle}>
                    Commander un trajet stuart
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Choisissez l'horaire de retrait (par défaut celui choisi par le client).
                </Typography>


                <div style={{textAlign: "center"}}>
                    <input style={inputDateTimeStyle} type="datetime-local"  value={new Date(chosenDate*1000).toISOString().slice(0, new Date(chosenDate*1000).toISOString().length-8)} onChange={(e) => {if(!isNaN(e.target.valueAsNumber)) {setChosenDate(e.target.valueAsNumber/1000)}}} />
                    

                    <MUIButtonGroup variant="contained" aria-label="outlined primary button group" style={buttonGroupStyle}>
                        <MUIButton color="error" onClick={() => handleClose()}>Annuler</MUIButton>
                        <MUIButton color="secondary" onClick={() => {
                            handleClose();
                            let chosenDateTZ = timezoneToUtc(chosenDate);
                            if(type.localeCompare("pickup") == 0){
                                orderPickup(orderId, chosenDateTZ)
                            }
                            else {
                                orderDelivery(orderId, chosenDateTZ)
                            }
                        }}>Valider le trajet</MUIButton>
                    </MUIButtonGroup>
                </div>

            </Box>
        </Modal>
    );
}